export const checkIsAppPage = () => {
    return (
        window.location.pathname.indexOf('/p/') === 0 ||
        window.location.pathname.indexOf('/pl/') === 0 ||
        window.location.pathname.indexOf('/pt/') === 0
    );
};
